import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";

export const INVENTORY_STATUS = {
  NEW: 'Inventário novo',
  PENDING: 'Inventário em criação',
  EXECUTED: 'Inventário finalizado',
}


class InventoryStatusSelector extends BaseSelectorReadonlyToInput {

  inventoryStatusData = Object.keys(INVENTORY_STATUS).map(value => ({ value, label: INVENTORY_STATUS[value] }))

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: props.title || 'Status do inventário',
      label: 'label',
      placeholder: props.placeholder,
      style: props.style,
      items: this.inventoryStatusData
    };
  }
}

export default InventoryStatusSelector



// WEBPACK FOOTER //
// ./src/Inventory/components/InventoryStatusSelector.js